import { __assign } from "tslib";
import { log, LogKind } from '@ms/centro-hvc-loader';
import { TelemetryPrefix } from './Constants';
/**
 * Logs errors into the centro telemetry
 */
export function logError(id, text, error, data) {
    log({
        id: id,
        type: LogKind.Error,
        message: "".concat(TelemetryPrefix, ": ").concat(text),
        error: error,
        data: __assign(__assign({}, data), { timestamp: Date.now() }),
    });
    throw error;
}
/**
 * Logs info into the centro telemetry
 */
export function logInfo(id, text, data) {
    log({ id: id, type: LogKind.Info, message: "".concat(TelemetryPrefix, ": ").concat(text), data: __assign(__assign({}, data), { timestamp: Date.now() }) });
}
export { LoggingTags } from '@ms/ocv-inapp-feedback-shared';
